import { Vue } from "vue-class-component";
import { Fancybox } from "@fancyapps/ui";
import { Options, Prop, Ref } from "vue-property-decorator";

@Options({})
export class FancyboxGallery extends Vue {
    @Prop() options = {};
    @Ref("container") container: any;
    mounted() {
        Fancybox.bind(this.container, "[data-fancybox]", {
            ...(this.options || {}),
        });
    }
    updated() {
        Fancybox.unbind(this.container);
        Fancybox.close();

        Fancybox.bind(this.container, "[data-fancybox]", {
            ...(this.options || {}),
        });
    }
    unmounted() {
        Fancybox.destroy();
    }
}
